import { RouteObject } from "react-router-dom";
import BillLanding from "./components/landing/landing";
export interface BxSearchRoutes extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BxSearchRoutes[];
}
export const bxSearchRoutes: BxSearchRoutes[] = [
  {
    path: "/bx/search",
    element: <BillLanding />,
  },
];
